import Box from "ds/components/Box";
import { AnalyticsPage } from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";

import { FiltersContext } from "..";
import { SavedFiltersContext } from "../SavedViews/Context";
import FiltersSavedViewsPanel from "../SavedViews/Panel";
import { FilterItem, FiltersApplyView } from "../types";
import FilterSection from "./FilterSection";
import FiltersSidebarSkeleton from "./FiltersSidebarSkeleton";
import SidebarActions from "./SidebarActions";

type FiltersTabProps = {
  analyticsPage?: AnalyticsPage;
  applyView: FiltersApplyView;
  filters: FilterItem[];
  loading: boolean;
};

const FiltersTab = ({
  analyticsPage,
  applyView,
  filters,
  loading: loadingFilters,
}: FiltersTabProps) => {
  const { enableViews } = useTypedContext(FiltersContext);
  const { loading: savedViewsLoading } = useTypedContext(SavedFiltersContext);

  const loading = savedViewsLoading || loadingFilters;

  return (
    <Box direction="column">
      {!loading && enableViews && <FiltersSavedViewsPanel applyView={applyView} />}

      {filters.length > 1 && <SidebarActions analyticsPage={analyticsPage} />}

      {!loading ? (
        filters.map((filterItem, i) => (
          <FilterSection
            key={filterItem.key}
            filterItem={filterItem}
            isLastLabelsFilter={
              filterItem.filterName === "label" && filters[i + 1]?.filterName !== "label"
            }
            analyticsPage={analyticsPage}
          />
        ))
      ) : (
        <FiltersSidebarSkeleton />
      )}
    </Box>
  );
};

export default FiltersTab;
